import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './skeleton.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  loading: Boolean,
  animated: Boolean,
  rows: Number,
  avator: Boolean,
  size: String
};
var defaults = function defaults() {
  return {
    rows: 2,
    size: 'large'
  };
};
export var Skeleton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Skeleton, _Component);
  function Skeleton() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Skeleton;
}(Component);
Skeleton.template = template;
Skeleton.typeDefs = typeDefs;
Skeleton.defaults = defaults;